import { refreshAuthentication } from 'affiny-core/modules/api/core/saga';
import { authActions } from 'affiny-core/modules/auth/actions';
import {
  fetchDataAndRedirect,
  reauthenticatePeriodically,
} from 'affiny-core/modules/auth/saga';
import { selectAccessToken } from 'affiny-core/redux/selectors/authSelectors';
import { call, put, select, spawn } from 'redux-saga/effects';

export function* bootstrapCoreSaga() {
  yield call(refreshAuthentication);
  const accessToken = yield select(selectAccessToken);

  if (accessToken) {
    yield call(fetchDataAndRedirect);
    yield spawn(reauthenticatePeriodically);
  }
}

export function* bootstrapErrorSaga() {
  const accessToken = yield select(selectAccessToken);

  if (accessToken) {
    // we need to perform a logout and not a simple navigation
    // when login succeeds but one of the calls in fetchDataAdnRedirect fails.
    // In this case we have to clean the stored information to avoid problems
    yield put(authActions.logout());
  } else {
    yield put(authActions.authDataCleanup());
  }
}
